<!--
Copyright (C) 2024 Checkmk GmbH - License: GNU General Public License v2
This file is part of Checkmk (https://checkmk.com). It is subject to the terms and
conditions defined in the file COPYING, which is part of this source code package.
-->
<script setup lang="ts">
interface CmkLoadingProps {
  height?: string
}
withDefaults(defineProps<CmkLoadingProps>(), {
  height: '8px'
})
</script>

<template>
  <div class="spinner">
    <div class="bounce1"></div>
    <div class="bounce2"></div>
    <div class="bounce3"></div>
  </div>
</template>

<style scoped>
/* stylelint-disable-next-line checkmk/vue-bem-naming-convention */
.spinner > div {
  width: v-bind(height);
  height: v-bind(height);
  background-color: var(--success-dimmed-2);
  border-radius: 100%;
  display: inline-block;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}

/* stylelint-disable-next-line checkmk/vue-bem-naming-convention */
.spinner .bounce1 {
  animation-delay: -0.32s;
}

/* stylelint-disable-next-line checkmk/vue-bem-naming-convention */
.spinner .bounce2 {
  animation-delay: -0.16s;
}

@keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    transform: scale(0);
  }

  40% {
    transform: scale(1);
  }
}

@keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    transform: scale(0);
  }

  40% {
    transform: scale(1);
  }
}
</style>
